import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addUserPersona } from "../redux/slices/currentUserSlice";
import { addDetailedPoints } from "../redux/slices/detailedPointsSlice";
import ProfileService from "../services/Profile";
import OtherService from "../services/Other";
import { fetchPdf } from "../constants/commonFunction";
import { Button } from "react-bootstrap";
import UhidModal from "./Modals/UhidModal";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import { FaRegCalendarAlt } from "react-icons/fa";
import FeatherIcon from "feather-icons-react";
import { Calendar } from "react-feather";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const TierCardNew = ({
  totalPoints,
  redemPoints,
  availablePoints,
  nextTarget,
  tierName,
  tierStar,
  awardCup,
}) => {
  const dispatch = useDispatch();
  const modalRef = useRef(null);
  const isUserAllInfo = useSelector(
    (state) => state.userTypeSlice.personalInfoResponse
  );
  const [userInformation, setUserInformation] = useState(null);
  const [detailedPoints, setDetailedPoints] = useState({});
  const [tdsPoints, setTdsPoints] = useState(0);
  const [bonusPoints, setBonusPoints] = useState(0);
  const [coolingPoints, setCoolingPoints] = useState(0);
  const [insuranceData, setInsuranceData] = useState(null);
  const [pdfLink, setPdfLink] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const userInfo = JSON.parse(localStorage.getItem("userData"));
  const hierDesc = userInfo.hierCode;
  const contactId = userInfo.dcm_contacts_id;

  useEffect(() => {
    dispatch(addUserPersona({ userPersona: userInfo.description }));
    setUserInformation(userInfo);
  }, []);

  const getDetailedPoints = async () => {
    try {
      const res = await OtherService.getDetailedPoints();
      dispatch(addDetailedPoints({ detailedPoints: res }));
      if (res.success) {
        setDetailedPoints(res?.response);
        setTdsPoints(res?.response?.tds_points);
        setBonusPoints(res?.response?.bonus_points);
        setCoolingPoints(res?.response?.cooling_points);
      }
    } catch (error) {
      console.error("getDetailedPoints API error");
    }
  };

  useEffect(() => {
    getDetailedPoints();
  }, []);

  const fetchInsuranceData = async () => {
    try {
      // if (hierDesc === "contractor") {
        const res = await ProfileService.getInsuranceData(contactId);
        if (res.success && res.data.length > 0) {
          const insurance = res.data[0];
          setInsuranceData(insurance);
          // const fileUrl = insurance.insurance_docs;
          // const fileExtension = fileUrl?.split(".").pop()?.toLowerCase();
          // if (fileExtension === "pdf") {
          //   fetchPdf(fileUrl).then((link) => {

          //     setPdfLink(link);
          //   });
          // } else if (["jpg", "jpeg", "png", "webp"].includes(fileExtension)) {

          //   setPdfLink(fileUrl);
          // }
        }
      // }
    } catch (error) {
      console.error("ProfileDataFetch Error");
    }
  };

  useEffect(() => {
    fetchInsuranceData();
  }, []);

  function handleShowUhidDetails() {
    if (insuranceData?.uhid && insuranceData?.uhid.length > 0) {
      setIsModalOpen(true);
    }
  }

  function formatNumberWithCommas(str = "") {
    if (str == "0" || !!str) {
      // return str.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      let new_str = Math.round(Number(str));
      return new_str.toLocaleString("en-IN");
    }
    return "0";
  }

  return (
    <>
      <div
        className="tierCardBg"
        style={{ minHeight: "375px", background: "none" }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <div>
              <div className="tierName">
                <span>Profile Info</span>
              </div>
            </div>
            <div className="tierCardDetails">
              <div className="tierDetails">
                {hierDesc === "contractor" ? (
                  <p>
                    Mobile No: {isUserAllInfo?.response?.message?.phone_number}
                  </p>
                ) : (
                  <p>SAP No: {isUserAllInfo?.response?.message?.member_id}</p>
                )}
              </div>
            </div>

            <div className="tierCardDetails">
              <div className="tierDetails">
                <p
                  style={{
                    cursor: "pointer",
                    color: "white",
                    textDecoration: "underline",

                  }}
                  onClick={handleShowUhidDetails}
                >
                  UHID:{" "}
                  {insuranceData?.uhid && insuranceData?.uhid.length > 0
                    ? insuranceData?.uhid
                    : "Not Available"}
                </p>
              </div>
            </div>

            <div className="tierCardDetails">
              <div
                className="tierDetails"
                style={{ display: "flex", justifyContent: "space-around" }}
              >
                <FaRegCalendarAlt
                  style={{
                    marginRight: "6px",
                    fontSize: "14px",
                    color: "#fff",
                  }}
                />
                <p style={{ fontSize: "13px" }}>
                  Enrollment Date:{" "}
                  {isUserAllInfo?.response?.message?.enrollment_date
                    ? new Date(
                        isUserAllInfo.response.message.enrollment_date
                      ).toLocaleString("en-IN", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        // hour: "numeric",
                        // minute: "numeric",
                        // hour12: true,
                      })
                    : "Not Available"}
                </p>
              </div>
            </div>
          </div>

          <div
            style={{
              minWidth: "165px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <img
              src={tierStar}
              alt="awardStar"
              className="awardStar"
              style={{ width: "80px", height: "80px", objectFit: "contain" }}
            />
            <div className="tierName">
              {tierName && <span>
                {tierName} Tier{" "}
                <img
                  src={awardCup}
                  alt="cup"
                  style={{
                    width: "16px",
                    height: "16px",
                    objectFit: "contain",
                    verticalAlign: "middle",
                  }}
                />
              </span>}
            </div>
          </div>
        </div>

        <div className="tierCardDetails" style={{ marginTop: "30px" }}>
          <div className="tierDetails">
            <p>{formatNumberWithCommas(totalPoints)}</p>
            <p className="smallText">Total Points</p>
          </div>
          <div style={{borderRight: "1px solid #c98a4c", height: "50px" }}/>
          <div className="tierDetails">
            <p>{formatNumberWithCommas(redemPoints)}</p>
            <p className="smallText">Redeemed Points</p>
          </div>
          <div style={{borderRight: "1px solid #c98a4c", height: "50px" }}/>
          <div className="tierDetails">
            <p>{formatNumberWithCommas(availablePoints)}</p>
            <p className="smallText">Available Points</p>
          </div>
        </div>

        <div className="tierCardDetails" style={{ marginTop: "30px" }}>
          <div className="tierDetails">
            <p>{formatNumberWithCommas(tdsPoints)}</p>
            <p className="smallText">TDS Points</p>
          </div>
          <div style={{borderRight: "1px solid #c98a4c", height: "50px" }}/>
          <div className="tierDetails">
            <p>{formatNumberWithCommas(bonusPoints)}</p>
            <p className="smallText">Bonus Points</p>
          </div>
          <div style={{borderRight: "1px solid #c98a4c", height: "50px" }}/>
          <div className="tierDetails">
            <p>{formatNumberWithCommas(coolingPoints)}</p>
            <p className="smallText">Cooling Points</p>
          </div>
        </div>
      </div>

      {isModalOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.2)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              borderRadius: "10px",
              width: "95%",
              maxWidth: "1000px",
              maxHeight: "95vh",
              overflowY: "auto",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "10px 20px",
                borderBottom: "1px solid #ddd",
                position: "sticky",
                top: 0,
                backgroundColor: "white",
                zIndex: 1,
              }}
            >
              <h5 style={{ margin: 0, fontWeight: "bold" }}>
                Insurance details
              </h5>
              <button
                onClick={() => setIsModalOpen(false)}
                style={{
                  background: "none",
                  border: "none",
                  fontSize: "20px",
                  cursor: "pointer",
                }}
              >
                ×
              </button>
            </div>

            {/* <div
              style={{
                height: "70vh",
                width: "48vw",
                margin: 0,
                padding: 0,
                overflow: "hidden",
                position: "relative",
                left: "50%",
                transform: "translateX(-50%)",
              }}
            >
              <iframe
                src={`${insuranceData?.insurance_docs}#toolbar=0&navpanes=0`}
                width="100%"
                height="100%"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  border: "none",
                  margin: 0,
                  padding: 0,
                  minWidth: "100%",
                  minHeight: "100%",
                }}
              />
            </div> */}
            <div
              style={{
                height: "50vh",
                width: "48vw",
                margin: 0,
                padding: 0,
                overflow: "hidden",
                position: "relative",
                left: "50%",
                transform: "translateX(-50%)",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {insuranceData?.insurance_docs &&
                (insuranceData.insurance_docs.toLowerCase().endsWith(".pdf") ? (
                  <iframe
                    src={`${insuranceData.insurance_docs}#toolbar=0&navpanes=0`}
                    width="100%"
                    height="100%"
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      border: "none",
                      margin: 0,
                      padding: 0,
                      minWidth: "100%",
                      minHeight: "100%",
                    }}
                  />
                ) : (
                  <img
                    src={insuranceData.insurance_docs}
                    alt="Insurance Document"
                    style={{
                      width: "80%",
                      height: "80%",
                      objectFit: "contain",
                    }}
                  />
                ))}
            </div>

            <div style={{ padding: "20px 30px", textAlign: "center" }}>
              <div style={{ textAlign: "left", lineHeight: 1.8 }}>
                {insuranceData?.description?.split("\n").map((line, index) => (
                  <div
                    key={index}
                    style={{ marginBottom: "4px", fontWeight: "lighter" }}
                  >
                    {line.trim()}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TierCardNew;
